import emoji from 'node-emoji'
import inquirer, { Answers } from 'inquirer'
import chalk from 'chalk'

import { ExtendedQuestion } from '../../../types'
import {
  CircleApiUtils,
  displayEnvCreationResults,
  circleApiQuestions,
  buildEnvQuestions,
  buildEnvsFromAnswers,
} from '../utils'

const askQuestions = inquirer.prompt

// eslint-disable-next-line no-shadow
export enum IOS_QUESTIONS_ENVS {
  APP_STORE_CONNECT_API_KEY_BASE64 = 'APP_STORE_CONNECT_API_KEY_BASE64',
  APP_STORE_CONNECT_ISSUER_ID = 'APP_STORE_CONNECT_ISSUER_ID',
  APP_STORE_CONNECT_KEY_ID = 'APP_STORE_CONNECT_KEY_ID',
  MATCH_PASSWORD = 'MATCH_PASSWORD',
  MATCH_AWS_ACCESS_KEY_ID = 'MATCH_AWS_ACCESS_KEY_ID',
  MATCH_AWS_SECRET_ACCESS_KEY = 'MATCH_AWS_SECRET_ACCESS_KEY',
  SLACK_URL = 'SLACK_URL',
}

export const iosQuestionsMap: { [key: string]: ExtendedQuestion } = {
  [IOS_QUESTIONS_ENVS.APP_STORE_CONNECT_API_KEY_BASE64]: {
    type: 'input',
    name: 'appStoreConnectApiKeyBase64',
    prefix: emoji.random().emoji,
    message: 'Please enter your base64 app store connect api key:',
  },
  [IOS_QUESTIONS_ENVS.APP_STORE_CONNECT_ISSUER_ID]: {
    type: 'input',
    name: 'appStoreConnectIssuerId',
    prefix: emoji.random().emoji,
    message: 'Please enter your app store connect issuer id:',
  },
  [IOS_QUESTIONS_ENVS.APP_STORE_CONNECT_KEY_ID]: {
    type: 'input',
    name: 'appStoreConnectKeyId',
    prefix: emoji.random().emoji,
    message: 'Please enter your app store connect key id:',
  },
  [IOS_QUESTIONS_ENVS.MATCH_PASSWORD]: {
    type: 'input',
    name: 'matchPassword',
    prefix: emoji.random().emoji,
    message: 'Please enter your match password:',
  },
  [IOS_QUESTIONS_ENVS.MATCH_AWS_ACCESS_KEY_ID]: {
    type: 'input',
    name: 'matchAwsAccessKeyId',
    prefix: emoji.random().emoji,
    message: 'Please enter your match aws access key id:',
  },
  [IOS_QUESTIONS_ENVS.MATCH_AWS_SECRET_ACCESS_KEY]: {
    type: 'input',
    name: 'matchAwsSecretAccessKey',
    prefix: emoji.random().emoji,
    message: 'Please enter your match aws secret access key:',
  },
  [IOS_QUESTIONS_ENVS.SLACK_URL]: {
    type: 'input',
    name: 'slackUrl',
    prefix: emoji.random().emoji,
    message: 'Please enter your slack url:',
  },
}

const buildIOSQuestions = (selectedEnvs: IOS_QUESTIONS_ENVS[]) => buildEnvQuestions(selectedEnvs, iosQuestionsMap)

const buildIOSEnvs = (selectedEnvs: IOS_QUESTIONS_ENVS[], iosEnvAnswers: Answers) =>
  buildEnvsFromAnswers(selectedEnvs, iosEnvAnswers, iosQuestionsMap)

// NOTE: this only works as a special case because key and values are the same.
export const iOSEnvsList = Object.keys(IOS_QUESTIONS_ENVS)

const circleQuestions = [
  ...circleApiQuestions,
  {
    type: 'checkbox',
    name: 'selectedEnvs',
    prefix: emoji.random().emoji,
    message: 'Please select the envs you would like to create/update:',
    choices: iOSEnvsList,
  },
]

export const createIOSCircleEnvs = async (): Promise<void> => {
  try {
    console.info(`${chalk.green('Creating CircleCI envs...')} \n`)
    const circleAnswers = await askQuestions(circleQuestions)
    const { selectedEnvs } = circleAnswers
    const iOSEnvQuestions = buildIOSQuestions(circleAnswers.selectedEnvs)
    const iOSEnvAnswers = await askQuestions(iOSEnvQuestions)

    const envs = buildIOSEnvs(selectedEnvs, iOSEnvAnswers)
    const utils = new CircleApiUtils({ token: circleAnswers.circleToken, projectSlug: circleAnswers.projectSlug })

    const creationResults = await utils.createEnvs(envs)
    displayEnvCreationResults(envs, creationResults)
  } catch (error) {
    console.error(error.message)
  }
}
